import React, { useEffect, useState } from "react";
import { Clock, AlertTriangle } from "lucide-react";
import { getSlaStatus, DEFAULT_SLA_MINUTES } from "../../utils/crmSla";

const CrmSlaBadge = ({ lead, slaMinutes = DEFAULT_SLA_MINUTES }) => {
  const [, tick] = useState(0);

  useEffect(() => {
    const status = getSlaStatus(lead, slaMinutes);
    if (!status || status.breached) return undefined;
    const id = window.setInterval(() => tick((n) => n + 1), 30000);
    return () => window.clearInterval(id);
  }, [lead, slaMinutes]);

  const status = getSlaStatus(lead, slaMinutes);
  if (!status) return null;

  if (status.breached) {
    return (
      <span className="crm-sla crm-sla--breached" title={`SLA breached — respond within ${slaMinutes}m`}>
        <AlertTriangle size={12} />
        SLA +{status.minutesOver}m
      </span>
    );
  }

  return (
    <span className="crm-sla crm-sla--active" title={`Respond within ${slaMinutes} minutes of enquiry`}>
      <Clock size={12} />
      {status.minutesLeft}m left
    </span>
  );
};

export default CrmSlaBadge;
